module.exports = __webpack_public_path__ + "img/ch_gallery_2.cba2dddd.jpg";